import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// user-client-mod -- LoginPage
//
// 登录页面，POST /api/auth/login
// - 用户名、密码
// - 客户端 fetch API 提交
// - 成功保存 token 并跳转个人资料页，失败显示错误
import * as React from 'react';
export function LoginPage() {
    const [error, setError] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const [hydrated, setHydrated] = React.useState(false);
    React.useEffect(() => {
        setHydrated(true);
        console.log('[LoginPage] Hydrated ✓');
    }, []);
    async function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('[LoginPage] handleSubmit called');
        setError(undefined);
        const formData = new FormData(e.currentTarget);
        const username = formData.get('username').trim();
        const password = formData.get('password');
        console.log('[LoginPage] Form data:', { username, passwordLength: password?.length });
        if (!username || !password) {
            console.log('[LoginPage] Validation: empty fields');
            setError('请填写用户名和密码');
            return;
        }
        setLoading(true);
        console.log('[LoginPage] Sending request...');
        try {
            const res = await fetch('/api/auth/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ strategy: 'password', username, password }),
            });
            console.log('[LoginPage] Response status:', res.status);
            const data = await res.json().catch(() => ({}));
            if (!res.ok) {
                console.log('[LoginPage] Error response:', data);
                setError(data.error || `登录失败 (${res.status})`);
                return;
            }
            console.log('[LoginPage] Login successful, user:', data.user);
            // 保存 token（localStorage，简单实现）
            if (data.accessToken) {
                localStorage.setItem('accessToken', data.accessToken);
                if (data.refreshToken) {
                    localStorage.setItem('refreshToken', data.refreshToken);
                }
            }
            // 跳转到个人资料页
            window.location.href = '/profile';
        }
        catch (err) {
            console.error('[LoginPage] Fetch error:', err);
            setError(err.message || '登录请求失败，请稍后重试');
        }
        finally {
            setLoading(false);
        }
    }
    console.log('[LoginPage] Render, hydrated:', hydrated, 'loading:', loading, 'error:', error);
    return (_jsxs("div", { className: "login-page", children: [_jsx("h1", { children: "\u767B\u5F55" }), !hydrated && _jsx("div", { className: "debug-info", children: "Hydrating..." }), error && _jsx("div", { className: "error", children: error }), _jsxs("form", { onSubmit: handleSubmit, noValidate: true, children: [_jsxs("div", { className: "form-field", children: [_jsx("label", { htmlFor: "username", children: "\u7528\u6237\u540D" }), _jsx("input", { id: "username", name: "username", type: "text", placeholder: "\u8BF7\u8F93\u5165\u7528\u6237\u540D", required: true, autoComplete: "username" })] }), _jsxs("div", { className: "form-field", children: [_jsx("label", { htmlFor: "password", children: "\u5BC6\u7801" }), _jsx("input", { id: "password", name: "password", type: "password", placeholder: "\u8BF7\u8F93\u5165\u5BC6\u7801", required: true, autoComplete: "current-password" })] }), _jsx("button", { type: "submit", disabled: loading, onClick: () => console.log('[LoginPage] Button clicked'), children: loading ? '登录中...' : '登录' })] }), _jsxs("p", { children: ["\u6CA1\u6709\u8D26\u53F7\uFF1F", _jsx("a", { href: "/register", children: "\u7ACB\u5373\u6CE8\u518C" })] })] }));
}
//# sourceMappingURL=login-page.js.map